import ExtPromotions from '@/components/ExtPromotions';

const ExtPage = () => {
    return <ExtPromotions />;
};

export default ExtPage;
